import React, { PropTypes } from 'react';
import Modal from 'react-modal';
import Translate from 'react-translate-component';

class AgreementDraftModal extends React.Component {

  static propTypes = {
    agreementDraft: PropTypes.object,
    close: PropTypes.func.isRequired
  };

  createMarkup (html) {
    return {__html: html};
  }

  renderContent () {
    if (this.props.agreementDraft) {
      return (
        <div>
          <h2>{this.props.agreementDraft.headline}</h2>
          <p dangerouslySetInnerHTML={this.createMarkup(this.props.agreementDraft.text)}></p>
        </div>
      );
    }

    return (
      <p><Translate content='INVOICE_TERMS_AND_CONDITIONS_EMPTY'/></p>
    );
  }

  render () {
    return (
      <Modal
        className='modal'
        contentLabel=''
        isOpen
        onRequestClose={this.props.close}>
        <div className='modal-content confirm-modal'>
          <button className='close' onClick={this.props.close}></button>
          {this.renderContent()}
          <button className="btn" onClick={this.props.close}><Translate content='CLOSE'/></button>
        </div>
      </Modal>
    );
  }

}

export default AgreementDraftModal;



/** WEBPACK FOOTER **
 ** ./src/views/invoice-tool/footer/agreement-draft/agreement-draft-modal.js
 **/